import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface MenuItemContentProps {
  icon?: ReactNode;
  activeIcon?: ReactNode;
  active?: boolean;
  content: string | ReactNode;
}

const MenuItemContent: FC<MenuItemContentProps> = ({ icon, activeIcon, content, active }) => (
  <>
    {icon && (active ? activeIcon : icon)}
    <MenuItemLabel>{content}</MenuItemLabel>
  </>
);

const MenuItemLabel = styled.span`
  margin-top: ${({ theme }) => theme.margins.small};
`;

export default MenuItemContent;
